module.exports = __webpack_public_path__ + "img/burner-mining-drill-N.6ab57806.png";